<template >
  <div class="mainUser">
    <!-- <menberMenu
      :tit-names="titNames"
      class="topNav"
      :tit-urls="titUrls"
    ></menberMenu> -->
    <div style="margin-top: 20px"></div>
    <query
      :queryParma="queryParma"
      @queryMethod="clkQuery"
      :cargoData="cargoData"
      :cargoList="cargoList"
      @childFn="parentFn"
      :weightDensity="weightDensity"
      :volumeDensity="volumeDensity"
      @ShipmentTotal="ShipmentTotal"
    />
    <air-result
      v-if="(queryRes && queryRes.List.length > 0) || isSort"
      @queryMethod="clkQuery"
      :queryParma="queryParma"
      :result="queryRes"
      :cargoData="cargoData"
      :sumList="sumList"
      :isCheckSortBy="isCheckSortBy"
    />
    <div v-show="!queryRes" style="height: 300px">
      <!-- <p>
        <img
          src="../../../assets/img/loading.gif"
          style="width: 50px; height: 50px; margin: 100px auto"
        />
      </p> -->
      <progress-loading v-if="!queryRes"></progress-loading>
    </div>
    <div
      class="listDataNone"
      v-show="queryRes && queryRes.List.length === 0 && !isSort"
      style="height: 300px"
    >
      <div class="textNone">
        <!-- <p class="marBot10">
          <i class="fa fa-cry" style="font-size: 60px; color: #d3d3d3"></i>
        </p>
        <p style="color: #9b9b9b">
          {{
            queryParma.IsSHReport === false
              ? "For internal/distribution cargo, please inquire the price for departure from Hong Kong."
              : "There is no real-time quote for Freightshop, you can contact customer service."
          }}
        </p> -->
        <div class="empty-box">
          <img src="/static/img/fyImg/empty.png" width="167px" height="134px" />
          <p>
            No quotation found at moment,please contact our custom service to
            inquiry case by case.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import query from "./query/query";
import airResult from "./result/result";
import menberMenu from "@/components/userCenter/public/menberPageMenu.vue";
import { post, fetch, Del, put } from "@/ask/axios";
import { setCookie } from "@/ask/cookiejs";
import { elAlert } from "@/utils/bulletBox";
import EventBus from "@/ask/eventBus";
import ProgressLoading from "@/components/Reception/public/progressLoading.vue";
//import { log } from 'shelljs/src/common';
export default {
  components: { query, menberMenu, airResult, ProgressLoading },

  data() {
    return {
      titNames: "Air Freight",
      titUrls: ",",

      queryRes: null,
      queryParma: {},

      cargoData: [],
      cargoList: [],
      customerOwnerType: 2,
      CustomerID: 0,
      sumList: null,
      isCheckSortBy: false,
      type: "",
      //list:[]
      weightDensity: 0,
      volumeDensity: 0,
    };
  },
  computed: {
    isSort() {
      let falg = false;
      if (this.queryParma.ArrivalType === 1) {
        falg = true;
      }
      return falg;
    },
  },
  created() {
    //获取用户信息
    let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
    if (U_info) {
      this.customerOwnerType = U_info.CustomerOwnerType;
      this.CustomerID = U_info.CustomerID;
    }

    this.routeQuery();
    this.getTypeCargo();
  },

  methods: {
    ShipmentTotal(val) {
      this.sumList = val;
    },
    parentFn(val) {
      this.sumList = val;
    },
    getarrivalType(val) {
      this.type = val;
    },

    //  从query 中 拿到的参数 如果是不是isSkip 就全部跳转第一页
    clkQuery(parma, isSkip) {
      //console.log("=====11111",parma);
      if (parma.Weight) {
        this.weightDensity = Number(parma.Weight);
        this.volumeDensity = Number(parma.Volume);
      }

      let that = this;
      if (!isSkip) {
        parma.Skip = 0;
      }
      this.queryParma = parma;
      //console.log("====,,,,,,", parma);
      this.queryRes = null;

      //let url =this.$api01+"/api/InfoCustomer/AirCalculation/QueryPriceEn";
      let url = this.$api04 + "/Air/api/AirCalculation/QueryPriceEn";
      post(url, parma).then((res) => {
        if (res.IsOK == true) {
          // this.searchResult(
          //   res.Results.Total,
          //   "机场到机场",
          //   res.Results.Origin.join(),
          //   "",
          //   res.Results.Dest.join(),
          //   this.queryParma.endCountry,
          //   false
          // );
          this.queryRes = res.Results;
          //Sort by筛选 同时满足左侧栏的筛选条件
          if (parma.isResultBox) {
            that.isCheckSortBy = true;
            // let listAir = that.arrayforEach(parma.linelist);
            this.queryRes.List.forEach((item) => {
              //排序：Sort by——每次筛选后的结果，均按照当前选中的排序方式排序
              parma.destlist.forEach((val) => {
                parma.linelist.forEach((index) => {
                  if (
                    index == item.AirCompanyCode2 &&
                    val == item.StartAirPortCode3
                  ) {
                    item.showFee = false;
                    item.showleft = true;
                    // if(that.arrivalType){//直达
                    //   item.showleft =( item.AirArrivalType==1) ? true : false;
                    // }else{
                    //   item.showleft =true;
                    // }
                  }
                });
              });
            });

            var obj = {};
            // obj.newlist = newlist;
            obj.List = this.queryRes.List; //res.Results.List;
            obj.Airline = res.Results.Airline;
            obj.Dest = res.Results.Dest;
            obj.Origin = res.Results.Origin;
            obj.destlist = parma.destlist; ///返回点击sort by之前的左侧数据
            obj.linelist = parma.linelist;
            obj.oldOrigin = parma.oldOrigin;
            obj.oldAirline = parma.oldAirline;
            obj.arrivalTypeState = parma.arrivalType;
            this.queryRes = obj;
          } else {
            //  this.queryRes = res.Results;
            this.clearHistoryList(res.Results.List);
          }
          // console.log("有多少条====",this.queryRes);
        } else {
          elAlert(this, "error");
        }
      });
    },
    arrayforEach(array) {
      let list = [];
      if (array) {
        array.filter(function (item) {
          list.push(item.Code);
          return list;
        });
      }
      return list;
    },
    // 记录第一次查价的结果   并清空历史记录
    clearHistoryList(item) {
      item.forEach((item) => {
        item.showFee = false;
        item.showleft = true;
      });
      localStorage.removeItem("historyList");
      let obj = {
        List: item,
      };
      //console.log("====保存的数据====",obj);
      localStorage.setItem("historyList", JSON.stringify(obj));
    },
    //两个数组合并去重/取重复值
    getArrDifference(arr1, arr2) {
      // return arr1.concat(arr2).filter(function(v, i, arr) {
      //   return arr.indexOf(v) === arr.lastIndexOf(v);
      // });
      let newArr = [];
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (
            arr1[j].StartAirPortCode3 === arr2[i].StartAirPortCode3 &&
            arr1[j].AirCompanyCode2 === arr2[i].AirCompanyCode2 &&
            arr1[j].AirArrivalType === arr2[i].AirArrivalType
          ) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
    // 从地址栏里拿参数查询
    routeQuery() {
      let {
        code1,
        code2,
        unitQty,
        unitLabel,
        cbm,
        weight,
        cargoId,
        IsSHReport,
      } = this.$route.query;
      // if(this.$route.query.from==='card'){
      //         return
      //       }
      // this.queryParma = {
      //   OrderServiceType: 3, //机场到机场 默认是3
      //   QueryGoodType: 2,
      //   UnitLabel: unitLabel,
      //   QueryGoodUnit: 0,
      //   TotalQuanlity: unitQty,
      //   TotalWeight: weight,
      //   TotalCBM: cbm,
      //   GoodInfos: [],
      //   CargoTypeIDs: cargoId.split(","),
      //   IsSHReport: IsSHReport === null ? "" : IsSHReport === 0 ? false : true,
      //   IsQueryDisableAirChannel: false,
      //   LstStartAirPortCode3: code1.split(","),
      //   LstDestAirPortCode3: code2.split(","),
      //   ArrivalType: null,
      //   lstThWorkDays: [],
      //   OrderBy: "comprehensive",
      //   Skip: 0,
      //   Take: 5,
      // };
      let PackagingType=1;
      if(unitLabel != "CTNS"){
          PackagingType = 2;
      }
      this.queryParma = {
        skip: 0,
        take: 9999,
        orderBy: "price",
        orderByDesc: "aa",
        customerID: this.CustomerID,
        customerOwnerType: this.customerOwnerType,
        // orderServiceType: 5, //机场到机场 默认是3
        goodsReadyTime: new Date().Format("yyyy-MM-dd"), //"2021-06-24T06:25:09.016Z",//
        //channelKey: '',//渠道Key
        //channelOwnerType: 0,
        //startCityKey: this.$route.query.startCityKey,//起运城市Key
        startAirportCodeList:
          code1.split(",").length > 1 ? null : code1.split(","),
        destAirportCodeList: code2.split(","),
        arrivalType: null,
        //airCompanyKeyList: [],//航空公司Key
        weight: weight,
        volume: cbm,
        quantity: unitQty,
        cargoTypeIDList: cargoId.split(","),
        PackagingType:PackagingType,
        "platformType": "web",
        "isLogin": false,
        "entrance": "Air Freight"
      };
      //console.log("======22222",this.queryParma);
      let isGoods = true;
      if (this.queryParma.cargoTypeIDList == sysCfg.air.Cargo.generalCargoID) {
        isGoods = false;
      }
      let cargoArr = [];
      if (this.$route.query.cargoEn) {
        cargoArr = this.$route.query.cargoEn.split(",");
      }

      // console.log("货物种类===",cargoArr,sysCfg.air.Cargo.generalCargoID,this.queryParma.cargoTypeIDList);

      let text1 = "";
      if (this.$route.query.code1.length > 8) {
        text1 = "所有机场";
      } else {
        text1 = this.$route.query.code1; //+','+this.$route.query.code1En
      }

      let text2 = this.$route.query.code2; //+','+this.$route.query.code2En
      let inputWeight = this.$route.query.weight
        ? this.$route.query.weight
        : Number(this.queryParma.TotalWeight)
        ? Number(this.queryParma.TotalWeight)
        : 500;
      let inputCBM = this.$route.query.cbm
        ? this.$route.query.cbm
        : Number(this.queryParma.TotalCBM)
        ? Number(this.queryParma.TotalCBM)
        : 1.5;
      let inputUnits = this.$route.query.unitQty
        ? this.$route.query.unitQty
        : Number(this.queryParma.TotalQuanlity)
        ? Number(this.queryParma.TotalQuanlity)
        : 1;
      // this.checkPrice(
      //   "国际空运",
      //   text1,
      //   "",
      //   text2,
      //   this.$route.query.CountryNameCh,
      //   "",
      //   inputWeight,
      //   inputCBM,
      //   inputUnits,
      //   isGoods,
      //   cargoArr,
      //   false,
      //   "机场到机场"
      // );
      // let url =this.$api01+"/api/InfoCustomer/AirCalculation/QueryPriceEn";
      //console.log("========///",this.queryParma,code1.split(",").length);
      let url = this.$api04 + "/Air/api/AirCalculation/QueryPriceEn";
      post(url, this.queryParma).then((res) => {
        if (res.IsOK == true) {
          this.searchResult(
            res.Results.Total,
            "机场到机场",
            text1,
            "",
            text2,
            "",
            false
          );
          this.queryRes = res.Results;
          //console.log("========list",res.Results);
          this.clearHistoryList(res.Results.List);
        } else {
          elAlert(this, "error");
        }
      });
    },
    //获取货物种类
    getTypeCargo() {
      let param = {
        AttrMain_Code: "KYSHSpecial",
      };
      // let url = this.$api01 + "/api/Attribute/QueryList";
      let url = this.$api04 + "/Basics/api/Attribute/QueryList";
      post(url, param).then((res) => {
        this.cargoData = res.Results[0].valList;
        this.cargoData.forEach(item => {
              this.$set(item, 'Id', item.AttrVal_ID);
            })
        this.handleCargo(this.cargoData);
      });
    },
    handleCargo(data) {
      var arr = [[], []]; //分为两类
      data.forEach((ele) => {
        if (ele.Id !== sysCfg.air.Cargo.generalCargoID) {
          ele.otherEn = ele.AttrVal_ContentEn;
          arr[0].push(ele);
        } else {
          ele.otherEn =
            "My goods do not contain any of the above mentioned goods";
          arr[1].push(ele);
        }
      });
      this.cargoList = arr;
    },
  },
};
</script>
<style scoped>
.topNav {
  height: 40px;
  line-height: 40px;
  margin: 0 !important;
}
.mainUser {
  min-height: 100%;
}
.listDataNone {
  height: 160px;
  width: 100%;
}
.listDataNone .textNone {
  padding-top: 35px;
  overflow: hidden;
}
.listDataNone p,
.listDataNone p img {
  text-align: center;
  margin: auto;
  font-size: 14px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/reception/air/index.vue